import React from 'react';
import ValidatingInput from '../ValidatingInput/ValidatingInput';

export function OrganizationClientSegment(props) {
    const valueObject = clientSegments.find(cs => cs.id === props.dataSet[props.dataKey]);

    return (
        <ValidatingInput
            label={props.label}
            dataSet={props.dataSet}
            dataKey={props.dataKey}
            valueObject={valueObject}
            onChange={props.onChange}
            options={clientSegments}
            validationFn={(selectedClientSegment) => {
                return clientSegments.findIndex(cs => cs.id === selectedClientSegment.id) > -1
            }}
            validationType="select"
        />
    );
}

export const clientSegments = [
    { id: 0, label: 'Other', value: 'Other' },
    { id: 1, label: 'Workplaces', value: 'Workplaces' },
    { id: 2, label: 'Grocery stores', value: 'Grocery stores' },
    { id: 3, label: 'Hotels', value: 'Hotels' },
    { id: 4, label: 'Public spaces', value: 'Public spaces' },
    { id: 5, label: 'Hospitals', value: 'Hospitals' },
    { id: 6, label: 'Restaurants & Cafes', value: 'Restaurants & Cafes' }
];
